"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var __2 = require("../../../..");
var options = [
    'compare_suppliers',
    'compare_payment_methods',
    'switching_information',
    'ineligible_suppliers',
    'has_debt',
    'fixed_tariff',
];
var BehaviouralAdvicePriceComparisonGivenInput = function () {
    var _a, _b;
    var trans = __2.useSemantics().trans;
    var errors = formik_1.useFormikContext().errors;
    return (react_1.default.createElement(__1.FormControl, { errors: ((_b = (_a = errors.project) === null || _a === void 0 ? void 0 : _a.behavioural_advice) === null || _b === void 0 ? void 0 : _b.price_comparison_advice_given) || [], label: trans('project:slhh::labels.behavioural-advice-price-comparison-given') },
        react_1.default.createElement("div", { className: "flex flex-col" }, options.map(function (key) { return (react_1.default.createElement(__1.Checkbox, { key: "price_comparison_advice_given." + key, name: "project.behavioural_advice.price_comparison_advice_given", label: trans("project:slhh::enum.price-comparison-advice." + key), value: key })); }))));
};
exports.default = BehaviouralAdvicePriceComparisonGivenInput;
//# sourceMappingURL=BehaviouralAdvicePriceComparisonGivenInput.js.map